module.exports = __webpack_public_path__ + "media/images/photo/group294-6636bdaeb3f18681fd4a1c78bda3fd96.png";